import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordLaptopSettingsIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;

  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M17.8679 2.82039C17.2993 3.37324 16.2194 3.22075 16.2194 3.22075C16.2194 3.22075 16.063 2.17218 16.6321 1.61934C17.2006 1.067 18.2806 1.21949 18.2806 1.21949C18.2806 1.21949 18.437 2.26755 17.8679 2.82039ZM12 7.35075C12 9.02407 13.1529 10.9463 14.32 11.3527C14.7242 11.4935 15.1426 11.2992 15.4902 11.0569C15.7537 10.8733 16.0729 10.6984 16.3312 10.6984C16.5885 10.6984 16.9087 10.8733 17.1718 11.0569C17.5193 11.2992 17.9377 11.4935 18.3425 11.3527C19.1715 11.0641 19.9936 10.0099 20.4 8.82313C19.6125 8.60383 19.0381 7.91226 19.0381 7.09269C19.0381 6.34196 19.5206 5.69834 20.2068 5.42753C19.7647 4.66456 19.0423 4.26013 18.226 4.26013C17.8039 4.26013 17.4154 4.42537 17.1025 4.62376C16.6016 4.93997 16.0603 4.93997 15.56 4.62376C15.2466 4.42537 14.8586 4.26013 14.4365 4.26013C13.0904 4.26013 12 5.35919 12 7.35075Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 15V7C4 5.11438 4 4.17157 4.58579 3.58579C5.17157 3 6.11438 3 8 3H11M20 15V13.5M4.01953 15L3.49762 16.0154C2.05474 18.677 1.69543 20.0077 2.24387 21.0039C2.79231 22 4.24642 22 7.15462 22H16.8454C19.7536 22 21.2077 22 21.7561 21.0039C22.3046 20.0077 21.9452 18.677 20.5023 16.0154L19.9518 15H4.01953Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordLaptopSettingsIcon;
